import { FC } from 'react';

type ProfilePopupItemProps = {
  label: string;
  content?: string | null;
};

export const ProfilePopupItem: FC<ProfilePopupItemProps> = ({ label, content }) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-custom-warm-grey-500 font-medium">{label}</span>
      <span className="text-sm">{content}</span>
    </div>
  );
};
